import { useEffect, useRef, useState } from "react";

const Reveal = ({ children, delay = 0, className = "", as: Tag = "div" }) => {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const obs = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        setTimeout(() => setVisible(true), delay);
                        obs.unobserve(el);
                    }
                });
            },
            { threshold: 0.12 }
        );
        obs.observe(el);
        return () => obs.disconnect();
    }, [delay]);

    return (
        <Tag ref={ref} className={`reveal ${visible ? "in" : ""} ${className}`}>
            {children}
        </Tag>
    );
};

export default Reveal;
